import { render, staticRenderFns } from "./OverallSetup.vue?vue&type=template&id=20f7de3c&scoped=true"
import script from "./OverallSetup.vue?vue&type=script&lang=js"
export * from "./OverallSetup.vue?vue&type=script&lang=js"
import style0 from "./OverallSetup.vue?vue&type=style&index=0&id=20f7de3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f7de3c",
  null
  
)

export default component.exports